export const SMALL_BREAK_POINT = 576;
export const MEDIUM_BREAK_POINT = 768;
export const LARGE_BREAK_POINT = 992;
export const EXTRA_LARGE_BREAK_POINT = 1200;
